import React, { Component } from "react";
import { Typography, Button} from "@material-ui/core";
import LinkHelper from "./Link";

export default class LoginSuggestion extends Component {

    render() {
        return (
            <Typography variant="h5" color="secondary">
                Already have an account?   
                
                <LinkHelper to="/login"> Log in</LinkHelper>
                
            </Typography>
            
        );
    }

}